import AddAddressModal from "../../routes/modals/AddAddress";
import AppVersionChangeModal from "../../routes/modals/AppVersionChange";
import AskAIModal from "../../routes/modals/AskAI";
import BadImageViewModal from "../../routes/modals/BadInventoryImageViewModal";
import BookedSlotsDetailsModal from "../../routes/modals/BookedSlotsDetails";
import BookingsPaymentStatus from "../../routes/modals/BookingsPaymentStatus";
import CalendarBlockDetailsModal from "../../routes/modals/CalendarBlockDetails";
import CancelationModal from "../../routes/modals/Cancelation";
import CartItemAddModal from "../../routes/modals/CartItemAddModal";
import CartStockIncompleteModal from "../../routes/modals/CartStockIncompleteModal";
import CertificateDocumentDeleteModal from "../../routes/modals/CertificateDocumentDeleteModal";
import CertificateDocumentEditModal from "../../routes/modals/CertificateDocumentEditModal";
import CertificateDocumentUploadModal from "../../routes/modals/CertificateDocumentUploadModal";
import CertificateDocumentViewModal from "../../routes/modals/CertificateDocumentViewModal";
import CopyImageModal from "../../routes/modals/CopyImageModal";
import DeleteCartItemModal from "../../routes/modals/DeleteCartItemModal";
import EMRQuickViewModal from "../../routes/modals/EMRQuickView";
import EMRSubmissionModal from "../../routes/modals/EMRSubmission";
import EditBookingCommentModal from "../../routes/modals/EditBookingComment";
import GoodToBadModal from "../../routes/modals/GoodToBadModal";
import ImageCategoryModal from "../../routes/modals/ImageCategoryModal";
import InvalidImageModal from "../../routes/modals/InvalidImageModal";
import InventoryOnboardingSuccessModal from "../../routes/modals/InventoryOnboardingSuccess";
import IsOverbookingAllowedModal from "../../routes/modals/IsOverbookingAllowed";
import LogoutModal from "../../routes/modals/Logout";
import MembershipUsageModal from "../../routes/modals/MembershipUsageModal";
import MissingDetailsModal from "../../routes/modals/MissingDetails";
import BookingMissingDetailsEditModal from "../../routes/modals/MissingDetailsBooking";
import MrpUpdateModal from "../../routes/modals/MrpUpdateModal";
import NoInternetModal from "../../routes/modals/NoInternet";
import OverdraftEMRModal from "../../routes/modals/OverdraftEMR";
import PODeleteModal from "../../routes/modals/PODeleteModal";
import POStatusUpdateModal from "../../routes/modals/POStatusUpdate";

import PurchaseOrderSendRequestModal from "../../routes/modals/PurchaseOrderSendRequest";
import RefundInitiate from "../../routes/modals/RefundInitiate";
import RejectRequestModal from "../../routes/modals/RejectRequestModal";
import RequestSamplePickupModal from "../../routes/modals/RequestSamplePickupModal";
import RescheduleConfimationModal from "../../routes/modals/RescheduleConfimationModal";
import SelectCityAndClinicModal from "../../routes/modals/SelectCityAndClinic";
import SendAppRequestModal from "../../routes/modals/SendAppRequest";
import ShrinkImageModal from "../../routes/modals/ShrinkImageModal";
import ShrinkModal from "../../routes/modals/ShrinkModal";
import SpeechRecognitionModal from "../../routes/modals/SpeechRecognitionModal";
import TOSelectedItemModal from "../../routes/modals/TOSelectedItemModal";
import ThemeChangeModal from "../../routes/modals/ThemeChangeModal/ThemeChangeModal";
import AddTileModal from "../../routes/auth_routes/TilesConfiguration/TilesPage/AddTileModal";
import ViewTileModal from "../../routes/auth_routes/TilesConfiguration/TilesPage/ViewTileModal";
import DeleteTileModal from "../../routes/auth_routes/TilesConfiguration/TilesPage/DeleteTileModal";
import EditTileModal from "../../routes/auth_routes/TilesConfiguration/TilesPage/EditTileModal";
import SyncTileModal from "../../routes/auth_routes/TilesConfiguration/TilesPage/SyncTileModal";
import VaccinationEnterDataModal from "../../routes/modals/VaccinationEnterDataModal";
import VaccinationOverdueModal from "../../routes/modals/VaccinationOverdueModal";
import ViewCommentModal from "../../routes/modals/ViewComments";

const RootContainerModals = () => {
  return (
    <>
      <BookingMissingDetailsEditModal />
      <ViewCommentModal />
      <SendAppRequestModal />
      <LogoutModal />
      <CancelationModal />
      <RescheduleConfimationModal />
      <MissingDetailsModal />
      <BookedSlotsDetailsModal />
      <ImageCategoryModal />
      <CopyImageModal />
      <PurchaseOrderSendRequestModal />
      <AddAddressModal />
      <NoInternetModal />
      <SelectCityAndClinicModal />
      <OverdraftEMRModal />
      <EMRQuickViewModal />
      <AppVersionChangeModal />
      <InventoryOnboardingSuccessModal />
      <AskAIModal />
      <EMRSubmissionModal />
      <CalendarBlockDetailsModal />
      <EditBookingCommentModal />
      <SpeechRecognitionModal />
      <GoodToBadModal />
      <RefundInitiate />
      <POStatusUpdateModal />
      <BadImageViewModal />
      <BookingsPaymentStatus />
      <IsOverbookingAllowedModal />
      <ThemeChangeModal />
      <CartItemAddModal />
      <CartStockIncompleteModal />
      <DeleteCartItemModal />
      <ShrinkModal />
      <MrpUpdateModal />
      <RequestSamplePickupModal />
      <MembershipUsageModal />
      <VaccinationEnterDataModal />
      <PODeleteModal />
      <CertificateDocumentUploadModal />
      <CertificateDocumentEditModal />
      <CertificateDocumentViewModal />
      <CertificateDocumentDeleteModal />
      <TOSelectedItemModal />
      <VaccinationOverdueModal />
      <RejectRequestModal />
      <ShrinkImageModal />
      <InvalidImageModal />
      <AddTileModal />
      <ViewTileModal />
      <DeleteTileModal />
      <EditTileModal />
      <SyncTileModal />
    </>
  );
};

export default RootContainerModals;
